import { Link } from 'react-router-dom';
import { BookOpen, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface SidebarHeaderProps {
  isOpen: boolean;
  isMobile: boolean;
  onToggle: () => void;
}

export function SidebarHeader({ isOpen, isMobile, onToggle }: SidebarHeaderProps) {
  return (
    <div className="flex h-16 items-center justify-between px-4 border-b">
      {(isOpen || isMobile) && (
        <Link to="/dashboard" className="flex items-center gap-2">
          <BookOpen className="h-6 w-6 text-primary" />
          <span className="text-lg font-semibold">
            NumberzInsight
          </span>
        </Link>
      )}
      <Button
        variant="ghost"
        size="icon"
        onClick={onToggle}
        className="ml-auto"
        aria-label={isOpen ? "Collapse Menu" : "Expand Menu"}
      >
        {isOpen ? <ChevronLeft className="h-5 w-5" /> : <ChevronRight className="h-5 w-5" />}
      </Button>
    </div>
  );
}